import React from 'react';

const Store = ({ match }) => <div>Store {match.params.storeId}</div>;

export default Store;


// WEBPACK FOOTER //
// ./src/components/Store.js